"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOneSelectedFolder = exports.getOneSelectedFile = exports.getIsAnySelected = exports.getFolderTree = exports.getCurrentFolderData = exports.getCurrentFolder = exports.getBreadcrumbs = exports.getAllFiles = void 0;
var _reselect = require("reselect");
var _config = require("../config.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var getTopFolderId = function getTopFolderId(state) {
  return state.topFolderId;
};
var getCurrentFolderId = function getCurrentFolderId(state) {
  return state.currentFolderId;
};
var getFolders = function getFolders(state) {
  return state.folders;
};
var getFiles = function getFiles(state) {
  return state.files;
};
var getSelectedFiles = function getSelectedFiles(state) {
  return state.selectedFiles;
};
var getSelectedFolders = function getSelectedFolders(state) {
  return state.selectedFolders;
};
var getSelectedFolderUp = function getSelectedFolderUp(state) {
  return state.selectedFolderUp;
};
var getSortBy = function getSortBy(state) {
  return state.sortBy;
};
var getGlobalFilter = function getGlobalFilter(state) {
  return state.globalFilter;
};
var getFilter = function getFilter(state) {
  return state.filter;
};
var getLoadedFolders = function getLoadedFolders(state) {
  return state.loadedFolders;
};
var getCurrentFolderData = (0, _reselect.createSelector)(getCurrentFolderId, getFolders, getFiles, getSortBy, getGlobalFilter, getFilter, function (currentFolderId, folders, files, sortBy, globalFilter, filter) {
  var sortByName = function sortByName(a, b) {
    return a.name.localeCompare(b.name);
  };
  var sortByNewest = function sortByNewest(a, b) {
    return b.updatedAt.localeCompare(a.updatedAt);
  };
  return {
    folders: folders.filter(function (item) {
      return item.parentId === currentFolderId;
    }).sort(sortByName),
    files: files.filter(function (item) {
      var result = item.folderId === currentFolderId;
      var regex = (_config.globalFilters[globalFilter] || {}).regex;
      if (regex) {
        result = result && regex.test(item.name.toLowerCase());
      }
      if (filter) {
        result = result && item.name.toLowerCase().includes(filter.toLowerCase());
      }
      return result;
    }).map(function (item) {
      if (item.thumbnailSmall) {
        return item;
      }
      var extension = (item.name.match(/\.([^.]+)$/) || ['', ''])[1];
      if (!_config.typeThumbnails[extension]) {
        return item;
      }
      var thumbnailSmall = process.env.NODE_ENV === 'test' ? 'mock' : _config.typeThumbnails[extension];
      return _objectSpread(_objectSpread({}, item), {}, {
        thumbnailSmall: thumbnailSmall,
        thumbnailLarge: thumbnailSmall
      });
    }).sort(sortBy === 'filename' ? sortByName : sortByNewest)
  };
});
exports.getCurrentFolderData = getCurrentFolderData;
var getCurrentFolder = (0, _reselect.createSelector)(getTopFolderId, getCurrentFolderId, getFolders, function (topFolderId, currentFolderId, folders) {
  return topFolderId === currentFolderId ? {
    id: currentFolderId,
    path: ''
  } : folders.find(function (item) {
    return item.id === currentFolderId;
  });
});
exports.getCurrentFolder = getCurrentFolder;
var getBreadcrumbs = (0, _reselect.createSelector)(getTopFolderId, getCurrentFolderId, getFolders, function (topFolderId, currentFolderId, folders) {
  var result = [];
  var addFolder = function addFolder(id) {
    if (id === topFolderId) {
      result.push({
        id: topFolderId,
        name: 'Assets'
      });
      return;
    }
    var folder = folders.find(function (item) {
      return item.id === id;
    });
    result.push({
      id: id,
      name: folder.name
    });
    addFolder(folder.parentId);
  };
  addFolder(currentFolderId);
  return result.reverse();
});
exports.getBreadcrumbs = getBreadcrumbs;
var getOneSelectedFile = (0, _reselect.createSelector)(getSelectedFiles, getSelectedFolders, getFiles, function (selectedFiles, selectedFolders, files) {
  if (selectedFiles.length !== 1 || selectedFolders.length !== 0) {
    return null;
  }
  return files.find(function (item) {
    return item.id === selectedFiles[0];
  }) || null;
});
exports.getOneSelectedFile = getOneSelectedFile;
var getOneSelectedFolder = (0, _reselect.createSelector)(getSelectedFiles, getSelectedFolders, getFolders, function (selectedFiles, selectedFolders, folders) {
  if (selectedFolders.length !== 1 || selectedFiles.length !== 0) {
    return null;
  }
  return folders.find(function (item) {
    return item.id === selectedFolders[0];
  }) || null;
});
exports.getOneSelectedFolder = getOneSelectedFolder;
var getIsAnySelected = (0, _reselect.createSelector)(getOneSelectedFile, getOneSelectedFolder, getSelectedFolderUp, function (selectedFile, selectedFolder, selectedFolderUp) {
  return selectedFile || selectedFolder || selectedFolderUp;
});
exports.getIsAnySelected = getIsAnySelected;
var getFolderTree = (0, _reselect.createSelector)(getTopFolderId, getFolders, getLoadedFolders, function (topFolderId, folders, loadedFolders) {
  var getChildren = function getChildren(parentId) {
    return folders.filter(function (item) {
      return item.parentId === parentId;
    }).map(function (item) {
      return {
        id: item.id,
        name: item.name,
        loaded: loadedFolders.includes(item.id),
        children: getChildren(item.id)
      };
    });
  };
  return [{
    id: topFolderId,
    name: 'Assets',
    loaded: true,
    children: getChildren(topFolderId)
  }];
});
exports.getFolderTree = getFolderTree;
var getAllFiles = (0, _reselect.createSelector)(getTopFolderId, getFiles, getFolders, function (topFolderId, files, folders) {
  return files.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      path: item.folderId === topFolderId ? '/' + item.name : folders.find(function (folder) {
        return folder.id === item.folderId;
      }).path + '/' + item.name
    });
  });
});
exports.getAllFiles = getAllFiles;